export let LegalType = /*#__PURE__*/function (LegalType) {
  LegalType["PHYSICAL"] = "PHYSICAL";
  LegalType["LEGAL"] = "LEGAL";
  LegalType["WITHOUT"] = "WITHOUT";
  return LegalType;
}({});
export let IdentityDocumentType = /*#__PURE__*/function (IdentityDocumentType) {
  IdentityDocumentType["DNI"] = "DNI";
  IdentityDocumentType["NIE"] = "NIE";
  IdentityDocumentType["CIF"] = "CIF";
  IdentityDocumentType["PASSPORT"] = "PASSPORT";
  IdentityDocumentType["NIF_INHERITANCE"] = "NIF_INHERITANCE";
  IdentityDocumentType["TIE_RESIDENCE_CARD"] = "TIE_RESIDENCE_CARD";
  IdentityDocumentType["FOREIGN_DNI"] = "FOREIGN_DNI";
  IdentityDocumentType["NIF_MINOR_AGE"] = "NIF_MINOR_AGE";
  IdentityDocumentType["OTHERS"] = "OTHERS";
  return IdentityDocumentType;
}({});
export let PhoneType = /*#__PURE__*/function (PhoneType) {
  PhoneType["mobile"] = "mobile";
  PhoneType["landline"] = "landline";
  return PhoneType;
}({});
export let AddressType = /*#__PURE__*/function (AddressType) {
  AddressType["UNDEFINED"] = "UNDEFINED";
  AddressType["POSTAL"] = "POSTAL";
  AddressType["FISCAL"] = "FISCAL";
  AddressType["BIRTH"] = "BIRTH";
  AddressType["USUAL"] = "USUAL";
  AddressType["CURRENT"] = "CURRENT";
  return AddressType;
}({});
export let PersonSex = /*#__PURE__*/function (PersonSex) {
  PersonSex[PersonSex["UNDEFINED"] = 0] = "UNDEFINED";
  PersonSex[PersonSex["MALE"] = 1] = "MALE";
  PersonSex[PersonSex["FEMALE"] = 2] = "FEMALE";
  PersonSex[PersonSex["AMBIGUOUS"] = 3] = "AMBIGUOUS";
  PersonSex[PersonSex["UNKNOWN"] = 4] = "UNKNOWN";
  PersonSex[PersonSex["NOT_SPECIFIED"] = 5] = "NOT_SPECIFIED";
  PersonSex[PersonSex["OTHER_NO_VALUE"] = 6] = "OTHER_NO_VALUE";
  return PersonSex;
}({});
export let CustomerStatus = /*#__PURE__*/function (CustomerStatus) {
  CustomerStatus["ACTIVE"] = "ACTIVE";
  CustomerStatus["BLOCKED"] = "BLOCKED";
  CustomerStatus["UNSUBSCRIBED"] = "UNSUBSCRIBED";
  CustomerStatus["PROCESS_UNSUBSCRIBED"] = "PROCESS_UNSUBSCRIBED";
  CustomerStatus["IDLE"] = "IDLE";
  return CustomerStatus;
}({});
export let PersonLanguge = /*#__PURE__*/function (PersonLanguge) {
  PersonLanguge["ES"] = "ES";
  PersonLanguge["EN"] = "EN";
  PersonLanguge["FR"] = "FR";
  return PersonLanguge;
}({});